var _path, _g, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlocked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 124 124",
    enableBackground: "new 0 0 124 124",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(659.000000, 198.000000)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Combined-Shape_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -2547.1318,
    y1: 5.2921,
    x2: -2547.8564,
    y2: 6.0203,
    gradientTransform: "matrix(124 0 0 124.0002 315293 -840.0005)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4E6169"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#263238"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    opacity: 0.0616862,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#Combined-Shape_2_)",
    enableBackground: "new    ",
    d: " M-656.9-153l3.9,1.1c-3.9,14.6-2,30.2,5.1,43.4c15.2,28.3,50.1,38.6,77.8,23.1l0,0l2,3.7c-9.1,5.1-19.3,7.8-29.6,7.8 c-5.4,0-10.7-0.7-15.9-2.2C-646.3-85.2-665.7-119.6-656.9-153L-656.9-153z M-598.5-179c16.2,0,30.8,9.5,37.6,24.3 c9.7,21,0.6,46-20.2,55.7l0,0l-1.7-3.8c8-3.8,14.4-10.3,18.1-18.3c8.7-18.9,0.6-41.4-18.1-50.1c-18.7-8.8-40.9-0.6-49.6,18.3 c-8.7,18.9-0.6,41.4,18.2,50.1l0,0L-616-99c-14.6-6.9-24-21.7-24-38C-640-160.2-621.4-179-598.5-179z M-597.4-198 c8.1,0,16.1,1.6,23.6,4.6c31.9,13,47.2,49.5,34.2,81.4l0,0l-3.8-1.6c7.6-18.6,5.1-39.8-6.7-56.1c-18.8-26.1-55.3-31.9-81.3-13.1 l0,0l-2.4-3.4C-623.4-193.9-610.6-198-597.4-198z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fill-8"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#E8E8E8",
    d: "M-586.1-167h-21.7c-1.3,0-2.5,0.5-3.4,1.4l-15.3,15.3 c-0.9,0.9-1.4,2.1-1.4,3.4v21.7c0,1.3,0.5,2.5,1.4,3.4l15.3,15.3c0.9,0.9,2.1,1.4,3.4,1.4h21.7c1.3,0,2.5-0.5,3.4-1.4l15.3-15.3 c0.9-0.9,1.4-2.1,1.4-3.4v-21.7c0-1.3-0.5-2.5-1.4-3.4l-15.3-15.3C-583.7-166.5-584.9-167-586.1-167z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Combined-Shape_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -2535.7529,
    y1: 11.9643,
    x2: -2534.9395,
    y2: 11.9643,
    gradientTransform: "matrix(56 0 0 56 141383 -806)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EF453C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F83B6D"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape_1_",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#Combined-Shape_3_)",
    d: "M-587.4-164 c1.2,0,2.3,0.4,3.2,1.2l0.2,0.2l13.6,13.6c0.8,0.8,1.3,2,1.4,3.1v0.3v19.2c0,1.2-0.4,2.3-1.2,3.2l-0.2,0.2l-13.6,13.6 c-0.8,0.8-2,1.3-3.1,1.4h-0.3h-19.2c-1.2,0-2.3-0.4-3.2-1.2l-0.2-0.2l-13.6-13.6c-0.8-0.8-1.3-2-1.4-3.1v-0.3v-19.2 c0-1.2,0.4-2.3,1.2-3.2l0.2-0.2l13.6-13.6c0.8-0.8,2-1.3,3.1-1.4h0.3L-587.4-164L-587.4-164z M-586.8-161.6h-20.4 c-0.2,0-0.5,0.1-0.7,0.3l0,0l-14.4,14.4c-0.2,0.2-0.3,0.5-0.3,0.7l0,0v20.4c0,0.2,0.1,0.5,0.3,0.7l0,0l14.4,14.4 c0.2,0.2,0.5,0.3,0.7,0.3l0,0h20.4c0.2,0,0.5-0.1,0.7-0.3l0,0l14.4-14.4c0.2-0.2,0.3-0.5,0.3-0.7l0,0v-20.4c0-0.2-0.1-0.5-0.3-0.7 l0,0l-14.4-14.4C-586.3-161.5-586.6-161.6-586.8-161.6L-586.8-161.6z M-587.2-160c0,0,0.1,0,0.2,0.1l0,0l13.9,13.9 c0,0,0.1,0.1,0.1,0.2l0,0v19.7c0,0,0,0.1-0.1,0.2l0,0L-587-112c0,0-0.1,0.1-0.2,0.1l0,0h-19.7c0,0-0.1,0-0.2-0.1l0,0l-13.9-13.9 c0,0-0.1-0.1-0.1-0.2l0,0v-19.7c0,0,0-0.1,0.1-0.2l0,0l13.9-13.9c0,0,0.1-0.1,0.2-0.1l0,0H-587.2z M-596.6-129.9 c-0.8,0-1.5,0.2-2,0.7s-0.8,1.1-0.8,1.8s0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.7,2,0.7s1.5-0.2,2-0.7s0.8-1.1,0.8-1.8 c0-0.7-0.3-1.4-0.8-1.8S-595.8-129.9-596.6-129.9z M-593.9-147.2h-5.4l0.6,15.1h4.1L-593.9-147.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocked);
export default __webpack_public_path__ + "static/media/blocked.b81df31e38690dfe8d0507b107f3929c.svg";
export { ForwardRef as ReactComponent };